
import { UserDevice } from "@/models/user-device";
import { CompanyUserDeviceService } from "@/services/company-user-device-service";
import Vue from "vue";
import { ConfirmResult } from "winfakt-vue-components";
import AppCompanyEditUserDeviceEdit from "./CompanyEditUserDeviceEdit.vue";

export default Vue.extend({
	data(){
		return {
			devices: [] as UserDevice[],
			toEditDevice: null as null | UserDevice
		};
	},
	props: {
		companyId: {
			type: Number,
			required: true
		}
	},
	methods: {
		async fetchDevices(){
			this.devices = await CompanyUserDeviceService.listDevices(this.companyId);
		},
		editDevice(device:UserDevice){
			this.toEditDevice = new UserDevice(device.getJSON());
		},
		createNewDevice(){
			this.toEditDevice = new UserDevice();
		},
		async onSaveDevice(){
			await this.fetchDevices();
		},
		async deleteDevice(device:UserDevice){
			let confirm = await this.$wf.confirm(`Weet je zeker dat je "${device.name}" wilt verwijderen?`, "Ja", "Nee", "danger", "Waarschuwing");
			if (confirm != ConfirmResult.YES) return;
			await CompanyUserDeviceService.deleteDevice(device);
			this.fetchDevices();
		},
		closeEdit(){
			this.toEditDevice = null;
		},
		close(){
			this.$emit("close");
		}
	},
	async mounted(){
		await this.fetchDevices();
	},
	components: {
		AppCompanyEditUserDeviceEdit
	}
});
